module.exports = __webpack_public_path__ + "img/login-btn.1ecd4d9c.png";